export enum SchedulerTypeEnum {
  Inspection = 'inspection',
  Permit = 'permit',
  Task = 'task'
}
